export default __webpack_public_path__ + "9f9395dc5b0c9fb561ea90b430eeac6c.svg";